import type { Types } from '../types';
import type { OutTypes } from './schedules';
import { getVertexId } from '../util';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { BaseOptions } from '../../common/types';
import type { EventVertex } from '../interfaces/vertices/events';




export default (
  events:  Types.Mixed.Event[],
  options: BaseOptions
): OutTypes.event[] => {
  return events
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<EventVertex> = {
        period:          x.period          ? getVertexId(x.period,          options) : undefined,
        linkedEventsSet: x.linkedEventsSet ? getVertexId(x.linkedEventsSet, options) : undefined,
        course:          x.course          ? getVertexId(x.course,          options) : undefined,
        lockedTimes:     x.lockedTimes ?.map(x => getVertexId(x, options)),
        exceptions:      x.exceptions  ?.map(x => getVertexId(x, options)),
        teachers:        x.teachers    ?.map(x => ({ ...x, to: getVertexId(x.to, options) })),
        participants:    x.participants?.map(x => ({ ...x, to: getVertexId(x.to, options) })),
        groups:          x.groups      ?.map(x => ({ ...x, to: getVertexId(x.to, options), exclude: x.exclude?.map(y => getVertexId(y, options)) })),
        locations:       x.locations   ?.map(x => ({ ...x, locations: [getVertexId(x.locations[0], options)] as [string] })),
        inLocations:     x.inLocations ?.map(x => x ? getVertexId(x, options) : null),
        threads:         undefined
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<EventVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};

